import { useMemo } from 'react';
import * as React from 'react';
import ListingContext, { ListingContextProps } from './ListingContext';

type ListingContextProviderProps = React.PropsWithChildren<ListingContextProps>;

function ListingContextProvider({
    theme,
    isPremium,
    hasProducts,
    children,
}: ListingContextProviderProps) {
    const contextValue = useMemo<ListingContextProps>(() => ({
        theme, isPremium, hasProducts,
    }), [theme, isPremium, hasProducts]);

    return (
        <ListingContext.Provider value={contextValue}>
            {children}
        </ListingContext.Provider>
    );
}

export default ListingContextProvider;
